<div class="empty-panel w-100">
  <ng-content></ng-content>
</div>
